export const paths = {
    authorized: [
        {
            route: '/home',
            view: 'home',
            layout: 'main'
        },
        {
            route: '/profile',
            view: 'profile',
            layout: 'main'
        },
        {
            route: '/career',
            view: 'career',
            layout: 'onlyFooter'
        },
        {
            route: '/shop',
            view: 'shop',
            layout: 'main'
        },
        {
            route: '/shop/:tab',
            view: 'shop',
            layout: 'main'
        },
        {
            route: '/leaderboard',
            view: 'leaderBoard',
            layout: 'main'
        },
        {
            route: '/leaderboard/info',
            view: 'leaderBoardInfo',
            layout: 'main'
        },
        {
            route: '/leaderboard/info/hints',
            view: 'leaderBoardHints',
            layout: 'main'
        },
        {
            route: '/leaderboard/info/rewards',
            view: 'leaderBoardRewards',
            layout: 'main'
        },
        {
            route: '/profile/edit',
            view: 'editProfile',
            layout: 'main'
        },
        {
            route: '/settings',
            view: 'profileSettings',
            layout: 'main'
        },
        {
            route: '/linkemail',
            view: 'linkEmail',
            layout: 'main'
        },
        {
            route: '/changepassword',
            view: 'changePassword',
            layout: 'main'
        },
        {
            route: '/accountlevel',
            view: 'accountLevel',
            layout: 'main'
        },
        {
            route: '/language',
            view: 'language',
            layout: 'main'
        },
        {
            route: '/tutorial',
            view: 'tutorial',
            layout: 'main'
        },
        {
            route: '/support',
            view: 'support',
            layout: 'main'
        },
        {
            route: '/about',
            view: 'about',
            layout: 'main'
        },
        {
            route: '/linkEmail',
            view: 'linkEmail',
            layout: 'main'
        },
        {
            route: '/club/:id',
            view: 'club',
            layout: 'club'
        },
        {
            route: '/club/:id/createTable',
            view: 'createTable',
            layout: 'plain'
        },
        {
            route: '/club/:id/nlh',
            view: 'tableParams',
            layout: 'plain'
        },
        {
            route: '/club/:id/plo',
            view: 'tableParams',
            layout: 'plain'
        },
        {
            route: '/club/:id/ofc',
            view: 'tableParams',
            layout: 'plain'
        },
        {
            route: '/league/:game',
            view: 'league',
            layout: 'plain'
        },
        {
            route: '/messages',
            view: 'messages',
            layout: 'onlyFooter'
        },
        {
            route: '/message/:mId',
            view: 'message',
            layout: 'onlyFooter'
        },
        {
            route: '/club/:id/message/:mId',
            view: 'message',
            layout: 'club'
        },
        {
            route: '/club/:id/messages',
            view: 'messages',
            layout: 'club'
        },
        // {
        //     route: '/club/:id/edit',
        //     view: 'editClub',
        //     layout: 'club'
        // },
        {
            route: '/club/:id/settings',
            view: 'clubSettings',
            layout: 'club'
        },
        {
            route: '/club/:id/newMessage',
            view: 'clubNewMessage',
            layout: 'club'
        },
        {
            route: '/club/:id/members',
            view: 'clubMembers',
            layout: 'club'
        },
        {
            route: '/club/:id/members/:memberId',
            view: 'clubMemberDetails',
            layout: 'club'
        },
        {
            route: '/club/:id/members/:memberId/agentMenu',
            view: 'agentMenu',
            layout: 'club'
        },
        {
            route: '/club/:id/members/:memberId/help',
            view: 'unionClubDataHelp',
            layout: 'plain'
        },
        {
            route: '/club/:id/buyLevel',
            view: 'clubBuyLevel',
            layout: 'club'
        },
        {
            route: '/club/:id/counter',
            view: 'clubCounter',
            layout: 'club'
        },
        {
            route: '/club/:id/trades',
            view: 'tradeRecord',
            layout: 'club'
        },
        {
            route: '/club/:id/counter/transfer',
            view: 'transfer',
            layout: 'club'
        },
        {
          route: '/club/:id/data',
          view: 'clubData',
          layout: 'club'
        },
        {
            route: '/club/:id/grandCredit',
            view: 'grandCreditHistory',
            layout: 'club'
          },
        {
            route: '/union/:id',
            view: 'unionMenu',
            layout: 'plain'
        },
        {
            route: '/union/:id/clubs',
            view: 'unionClubList',
            layout: 'plain',
        },
        {
            route: '/union/:id/requests',
            view: 'unionJoinRequests',
            layout: 'plain',
        },
        {
            route: '/union/:id/data',
            view: 'unionClubData',
            layout: 'plain',
        },
        {
            route: '/union/:id/edit',
            view: 'unionEdit',
            layout: 'plain',
        },
        {
            route: '/union/:id/data/help',
            view: 'unionClubDataHelp',
            layout: 'plain',
        },
        {
            route: '/autoLogin',
            view: 'autoLogin',
            layout: 'plain'
        },
    ],
    nonAuthorized: [
        {
            route: '/login',
            view: 'signIn',
            layout: 'plain'
        },
        {
            route: '/autoLogin/:skinId/:username/:token',
            view: 'autoLogin',
            layout: 'plain'
        },
        {
            route: '/autoLogin',
            view: 'autoLogin',
            layout: 'plain'
        },
        {
            route: '/register',
            view: 'signUp',
            layout: 'plain'
        },
        {
            route: '/forgotpassword',
            view: 'passwordRecovery',
            layout: 'plain'
        }
    ]
};

